/* Delegated on document (not bound per-toggle at DOMContentLoaded): a Quick Add /
   Quick Buy popup fetches the product page and injects a fresh copy of this size
   guide well after DOMContentLoaded has already fired, so a toggle wired up only at
   that one-time event never gets a listener when it's the modal's copy. Delegation
   binds once, checks the actual event target when it fires, and so works the same
   whether the toggle was in the original page markup or added to the DOM later. */
document.addEventListener("change", function (e) {
  const toggle = e.target.closest(".bh-unit-toggle");
  if (!toggle) return;

  const guide = toggle.closest(".bh-size-guide");
  if (!guide) return;

  const labels = guide.querySelectorAll(".bh-unit-label");
  const convertItems = guide.querySelectorAll(".convert-unit");
  const notes = guide.querySelectorAll("[data-original]");

  if (!convertItems.length && !notes.length) {
    /* This size guide's markup is hand-authored in a Shopify Page (it isn't
       part of the theme), so a content edit can accidentally drop the
       class/attribute the toggle depends on with no visible symptom other
       than the toggle doing nothing. Surfacing it here at least makes that
       diagnosable instead of silent. Required markup: wrap the guide in
       .bh-size-guide, the checkbox in .bh-unit-toggle, the two labels in
       .bh-unit-label, and add class="convert-unit" to any cell/text that
       contains an inch measurement (e.g. 72"). */
    console.warn('[bh-size-guide] IN/CM toggle switched, but no ".convert-unit" or "[data-original]" elements were found inside this .bh-size-guide. The linked page\'s content may be missing the expected markup.');
    return;
  }

  function convertToCM(text) {
    return text.replace(/(\d+(\.\d+)?)"/g, function (match, num) {
      return (num * 2.54).toFixed(1).replace(".0", "") + " cm";
    });
  }

  // Captures the current (inches) text into the given attribute the first
  // time an item is seen, instead of requiring it to be hand-typed into the
  // page's HTML up front. That removes one way for a content edit to go
  // stale: whatever inches text is on the page when the toggle is first used
  // becomes the source of truth automatically, so there's no separate
  // data-inches/data-original copy for an editor to forget to keep in sync.
  function ensureSource(el, attr) {
    if (!el.hasAttribute(attr)) {
      el.setAttribute(attr, el.textContent.trim());
    }
    return el.getAttribute(attr);
  }

  const isCM = toggle.checked;

  convertItems.forEach(function (item) {
    const original = ensureSource(item, "data-inches");
    item.textContent = isCM ? convertToCM(original) : original;
  });

  notes.forEach(function (note) {
    const original = ensureSource(note, "data-original");
    note.textContent = isCM ? convertToCM(original) : original;
  });

  if (labels.length >= 2) {
    labels[0].classList.toggle("active", !isCM);
    labels[1].classList.toggle("active", isCM);
  }
});